import React from "react";
import useTranslation from "../../hooks/useTranslation";

export default function StatsCards({ totalDoctors, totalPatients, sessionsCount, highRiskCount }) {
  const { t } = useTranslation();
  return (
    <div className="admin-stats-grid">
      <div className="admin-card">
        <div className="admin-card-title">{t('Doctors')}</div>
        <div className="admin-card-value">{totalDoctors}</div>
      </div>
      <div className="admin-card">
        <div className="admin-card-title">{t('Patients')}</div>
        <div className="admin-card-value">{totalPatients}</div>
      </div>
      <div className="admin-card">
        <div className="admin-card-title">{t('Sessions')}</div>
        <div className="admin-card-value">{sessionsCount}</div>
      </div>
      <div className="admin-card">
        <div className="admin-card-title">{t('High Risk')}</div>
        <div className="admin-card-value">{highRiskCount}</div>
      </div>
    </div>
  );
}
